import * as XLSX from 'xlsx';

/**
 * Exports an array of objects to an Excel file (.xlsx) and triggers a download.
 * 
 * @param {Array} data - The array of objects to export.
 * @param {string} filename - The name of the file to be downloaded (without extension).
 */
export const exportToExcel = (data, filename) => {
  if (!data || data.length === 0) {
    console.warn("Tidak ada data untuk diekspor");
    return;
  }
  
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
  
  // Format current date for filename
  const dateStr = new Date().toISOString().split('T')[0];
  
  XLSX.writeFile(workbook, `${filename}_${dateStr}.xlsx`);
};
